// This file contains the environment variables for the project.

export const RELSIFY_URL = process.env.VUE_APP_RELSIFY_URL || "https://backend-staging.relsify.net"
export const DASHBOARD_URL = process.env.VUE_APP_DASHBOARD_URL || "https://app.relsify.com"
export const WEBSITE_URL = process.env.VUE_APP_WEBSITE_URL || "https://home.relsify.com"
export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID || '231300972707-b32s9k2iidsra2juts7onkkikjtr4nko.apps.googleusercontent.com'
export const FACEBOOK_APP_ID = process.env.VUE_APP_FACEBOOK_APP_ID || '510035063941430'
export const GOOGLE_TAG = process.env.VUE_APP_GOOGLE_TAG || "G-DSJ3BN94FH"